(function ($) {
	'use strict';

	$(function () {
		function checkifNavRequired(numSlides, navParent) {
			let numToCheck = 1;

			if (numSlides <= numToCheck) {
				navParent.css('display', 'none');
			} else {
				navParent.removeAttr('style');
			}
		}

		$('.js-form-carousel').each(function () {
			const sliderContainer = $(this);
			const sliderEl = $('.swiper', sliderContainer)[0];
			const navParent = $('.js-form-carousel-nav', sliderContainer);
			const numSlides = sliderEl.querySelectorAll('.js-carousel-slide').length;

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				loop: numSlides >= 3 ? true : false,
				autoHeight: true,
				slidesPerView: 1,
				centeredSlides: true,
				navigation: false,
				speed: 1000,
				spaceBetween: 20,

				autoplay: {
					delay: 10000,
				},

				on: {
					beforeInit: function () {
						checkifNavRequired(numSlides, navParent);

						if (numSlides >= 3) {
							$(".js-carousel-nav-prev", sliderContainer).removeClass('carousel-nav__button--disabled');
							$(".js-carousel-nav-prev", sliderContainer).removeAttr('disabled');
						}
					},

					resize: function () {
						checkifNavRequired(numSlides, navParent);
					},

					slideChange: function () {
						if (this.isBeginning && numSlides < 3) {
							$(".js-carousel-nav-prev", sliderContainer).addClass('carousel-nav__button--disabled');
							$(".js-carousel-nav-prev", sliderContainer).attr('disabled', 'disabled');
						} else {
							$(".js-carousel-nav-prev", sliderContainer).removeClass('carousel-nav__button--disabled');
							$(".js-carousel-nav-prev", sliderContainer).removeAttr('disabled');
						}

						if (this.isEnd && numSlides < 3) {
							$(".js-carousel-nav-next", sliderContainer).addClass('carousel-nav__button--disabled');
							$(".js-carousel-nav-next", sliderContainer).attr('disabled', 'disabled');
						} else {
							$(".js-carousel-nav-next", sliderContainer).removeClass('carousel-nav__button--disabled');
							$(".js-carousel-nav-next", sliderContainer).removeAttr('disabled');
						}
					},
				}
			});

			$('.js-carousel-nav-next', sliderContainer).each(function () {
				$(this).on('click', function () {
					swiper.slideNext();
				});
			});

			$('.js-carousel-nav-prev', sliderContainer).each(function () {
				$(this).on('click', function () {
					swiper.slidePrev();
				});
			});
		});
	});
})(jQuery, document, window);
